export type BreachTableRow = Record<string, string | number | boolean | null>;

export const SEARCHABLE_COLUMNS = new Set([
  "breach_id",
  "signal_id",
  "signal",
  "risks",
  "status",
  "assigned_to",
]);

export const FIXED_COLUMNS = new Set(["breach_id"]);

export const HIDDEN_COLUMNS = new Set<string>([
  "root_cause",
  "immediate_action",
  "capa_if_required",
  "escalation_level",
  "next_review_date",
  "comments",
  "signal_id",
  "risks",
  "threshold_breached",
]);

export const BREACH_COLUMN_ORDER = [
  "breach_id",
  "signal",
  "detection_date",
  "signal_value",
  "severity",
  "status",
  "assigned_to",
] as const;

export const TITLE_MAPPING = {
  breach_id: "Breach ID",
  signal_id: "Signal ID",
  signal: "Signal",
  risks: "Linked Risks",
  detection_date: "Detection Date",
  signal_value: "Signal Value",
  threshold_breached: "Threshold Breached",
  severity: "Severity",
  status: "Status",
  assigned_to: "Assigned To",
  root_cause: "Root Cause",
  immediate_action: "Immediate Action",
  capa_if_required: "CAPA (If Required)",
  escalation_level: "Escalation Level",
  next_review_date: "Next Review Date",
  comments: "Comments",
} satisfies Record<string, string>;

export const COLUMN_WIDTHS = {
  DEFAULT: 160,
  breach_id: 120,
  signal_id: 120,
  signal: 360,
  risks: 160,
  detection_date: 160,
  signal_value: 180,
  threshold_breached: 240,
  severity: 160,
  status: 140,
  assigned_to: 220,
  root_cause: 360,
  immediate_action: 360,
  capa_if_required: 170,
  escalation_level: 220,
  next_review_date: 170,
  comments: 320,
} satisfies Record<string, number>;
